import React from "react";
import { UnitConverter } from "@sisuwellness/utilities";
import { path } from "ramda";
import { Cell, Header } from "./commonElements";
import i18n from "../../../../i18n.js";

const handleCellConstruct = (row, settings) => {
    const weight = path(["value"], row);

    switch (settings.unitMeasurement) {
        case "imperial": {
            const weightInIm = UnitConverter.kgToStLbs(weight);
            return (
                <Cell
                    unit=""
                    row={row}
                    data-testid="weight"
                    value={
                        weight
                            ? `${weightInIm.stones} ${i18n.t("units.stone")} ${weightInIm.pounds.toFixed(1)} ${i18n.t(
                                  "units.pounds"
                              )}`
                            : null
                    }
                />
            );
        }
        default:
            return (
                <Cell
                    data-testid="weight"
                    row={row}
                    value={weight ? weight.toFixed(1) : null}
                    unit={i18n.t("units.kilograms")}
                />
            );
    }
};

export const weightDef = (iconTypes, settings) => ({
    minWidth: 92,
    accessor: "weight",
    Cell: row => handleCellConstruct(row, settings),
    Header: () => <Header label={i18n.t("words.weight")} iconType={iconTypes.weight} />
});
